class IkevConfigurationGuide {
    constructor(id) {
        this.branchID = id;
    }

    show(modalToHide = null){
        const thisClass = this;
        naja.makeRequest('GET', '/branches/?do=getIkevConfigurationGuide', {
            'branchID': this.branchID,
            'organizationID': new URLSearchParams(window.location.search).get('organizationID')
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response) {
                if(modalToHide){
                    modalToHide.find('.menu-spinner').remove();
                    modalToHide.modal('hide');
                }
                new bootstrap.Modal(document.getElementById('ikev_configuration_guide_modal'), {}).show();
                thisClass.testConnection();
                thisClass.clipboard();
            }
        });
    }

    clipboard(){
        const targets = $('.ikev_configuration_guide_copier');
        if(targets) {
            for (const target of targets) {
                    let clipboard = new ClipboardJS(target, {
                        container: document.getElementById('ikev_configuration_guide_modal'),
                        target: target,
                        text: function () {
                            return $(target).attr('value');
                        }
                    });
                    clipboard.on('success', function (e) {
                        const currentLabel = target.innerHTML;
                        if (target.innerHTML === 'Copied!') {
                            return;
                        }
                        // Update button label
                        target.innerHTML = 'Copied!';

                        // Revert button label after 3 seconds
                        setTimeout(function () {
                            target.innerHTML = currentLabel;
                        }, 3000);
                    });
            }
        }
    }
    testConnection(){
        const thisClass = this;
        $('#ikev-configuration-test-connection').click(function () {
            const thisElement = this;
            $(this).find('.spinner-border').removeClass('d-none');
            $(this).find('.spinner-border').disabled = true;
            $.ajax({
                url: '/branches/?do=testConnection',
                type: 'GET',
                dataType: '',
                data: {branchID: thisClass.branchID}
            }).done(function(data) {
                $(this).find('.spinner-border').addClass('d-none');
                $(this).find('.spinner-border').disabled = false;
                let branchStatus    = $('#ikev-configuration-guide');
                $(thisElement).find('.spinner-border').addClass('d-none');
                branchStatus.removeClass('text-danger');
                branchStatus.removeClass('text-success');
                if(data['is_connected']){
                    $('#branch-start-connection').addClass('d-none');
                    toastr.success('Connection test has been successfully. Cloud/Branch "'+data['name']+'" is currently connected to Gateway.');
                }else{
                    $('#branch-start-connection').removeClass('d-none');
                    toastr.error('Connection test has not been successful. Cloud/Branch "'+data['name']+'" is currently disconnected from Gateway.');
                }
                $('#last_test_datetime').text(data['connection_datetime']);

                if(data['is_connected']){
                    branchStatus.text('Connected');
                    branchStatus.addClass('text-success');
                }else{
                    branchStatus.text('Disconnected');
                    branchStatus.addClass('text-danger');
                }
            });
        });
    }

}
window.IkevConfigurationGuide = IkevConfigurationGuide;